<template>
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.0065 105.642C38.9568 105.642 43.7804 100.818 43.7804 94.8683C43.7804 88.918 38.9568 84.0944 33.0065 84.0944C27.0563 84.0944 22.2327 88.918 22.2327 94.8683C22.2327 100.818 27.0563 105.642 33.0065 105.642Z"
      fill="#CB80DE"
    />
    <path
      d="M101.623 105.642C107.574 105.642 112.397 100.818 112.397 94.8683C112.397 88.918 107.574 84.0944 101.623 84.0944C95.6732 84.0944 90.8496 88.918 90.8496 94.8683C90.8496 100.818 95.6732 105.642 101.623 105.642Z"
      fill="#CB80DE"
    />
    <path
      d="M113.959 70.898H110.878L93.2722 43.3683H101.74C107.287 43.3683 111.781 38.8739 111.781 33.3276V33.0407C111.781 27.4944 107.287 23 101.74 23H50.3361C44.8004 23 40.306 27.4838 40.2954 33.0301H13.6795C8.33504 33.0301 4 37.3545 4 42.7096V81.3212C4 86.6657 8.33504 91.0007 13.6795 91.0007H113.959C119.506 91.0007 124 86.5063 124 80.96C124 75.4137 119.506 70.9086 113.959 70.9086V70.898Z"
    />
    <path
      d="M110.889 70.9191H85.5477C83.4439 70.9191 81.7439 69.2191 81.7439 67.1153V59.614C81.7439 57.5102 83.4439 55.8102 85.5477 55.8102H101.198L110.889 70.9297V70.9191Z"
      fill="#CB80DE"
    />
    <path
      d="M55.1705 43.3789H18.2694C15.6464 43.3789 13.52 45.5053 13.52 48.1283V53.5471C13.52 56.1702 15.6464 58.2965 18.2694 58.2965H55.1705C57.7935 58.2965 59.9199 56.1702 59.9199 53.5471V48.1283C59.9199 45.5053 57.7935 43.3789 55.1705 43.3789Z"
      fill="#CB80DE"
    />
  </svg>
</template>

<script>
  export default {
    name: 'MotorhomeInsurance'
  }
</script>
